var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9344 10.6278C11.7796 11.4757 10.3856 11.934 8.95433 11.9371C7.52109 11.9338 6.12715 11.4754 4.97097 10.6278C2.16371 10.9451 0 13.1899 0 15.9318V18.0147C0 19.4706 0.710811 20.0101 1.96193 19.9999H15.9445C17.1959 20.0101 17.9067 19.4706 17.9067 18.0147V15.9318C17.9067 13.1896 15.7427 10.9434 12.9344 10.6278Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95424 0C7.57718 0 6.25825 0.546394 5.28476 1.51961C4.31321 2.49282 3.76709 3.81175 3.76709 5.18715C3.76709 6.56255 4.31321 7.88258 5.28476 8.85469C6.25825 9.8279 7.57718 10.3737 8.95424 10.3737C10.3291 10.3737 11.6483 9.8279 12.6215 8.85469C13.5947 7.88258 14.1408 6.56255 14.1408 5.18715C14.1408 3.81175 13.5944 2.49254 12.6215 1.51961C11.6483 0.546117 10.3291 0 8.95424 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.020ff822096a9de0481b6f3d011640ab.svg";
export { ForwardRef as ReactComponent };